import { jsxs, jsx } from "react/jsx-runtime";
import { memo, useReducer, useRef, useMemo } from "react";
import { Portal } from "../Portal.js";
import { Dialog } from "./Dialog.js";
import { DialogContext } from "./DialogContext.js";
import { dialogReducer, initialDialogState } from "./dialogReducer.js";
const DialogProvider = memo((props) => {
  const [dialogState, dispatch] = useReducer(dialogReducer, initialDialogState);
  const idSeed = useRef(1);
  const options = useMemo(() => {
    return {
      openDialog: (settings) => new Promise((promiseResolve) => {
        const dialogId = idSeed.current++;
        const resolve = (value) => {
          dispatch({
            type: "closeDialog",
            dialogId
          });
          promiseResolve(value);
        };
        dispatch({
          type: "openDialog",
          dialogId,
          dialog: {
            resolve,
            settings
          }
        });
      })
    };
  }, []);
  return /* @__PURE__ */ jsxs(DialogContext.Provider, { value: options, children: [
    props.children,
    Array.from(dialogState.dialogs, ([dialogId, dialogWithMetadata]) => /* @__PURE__ */ jsx(Portal, { to: dialogWithMetadata.settings.container, children: /* @__PURE__ */ jsx(Dialog, { settings: dialogWithMetadata, dialogId }) }, dialogId))
  ] });
});
export {
  DialogProvider
};
//# sourceMappingURL=DialogProvider.js.map
